<template>
  <el-dialog
    title="动态属性编辑"
    :visible.sync="state"
    width="30%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <tz-form
      width="110px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
import { queryEquipment } from '@/api/dictionary'

export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    user: Object,
    roles: Array
  },

  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '设备类型',
          field: 'deviceType',
          type: 'select',
          payload: [],
          rules: [{ required: true, message: '设备类型必填', trigger: 'blur' }]
        },
        {
          label: '模板类型',
          field: 'templateType',
          type: 'select',
          payload: [],
          rules: [{ required: true, message: '模板类型必填', trigger: 'blur' }]
        },
        {
          label: '属性名',
          field: 'attributeName',
          type: 'text',
          rules: [{ required: true, message: '属性名必填', trigger: 'blur' }]
        },
        {
          label: '属性标签',
          field: 'attributeLabel',
          type: 'text',
          rules: [{ required: true, message: '属性标签必填', trigger: 'blur' }]
        },
        {
          label: '是否必填',
          field: 'type',
          type: 'radio',
          radiolist: [
            {
              value: 0,
              label: '否'
            },
            {
              value: 1,
              label: '是'
            }
          ]
          // rules: [{ required: true, message: '仪器型号必填', trigger: 'blur' }]
        },
        {
          label: '状态',
          field: 'status',
          type: 'radio',
          radiolist: [
            {
              value: 1,
              label: '启用'
            },
            {
              value: 2,
              label: '禁用'
            }
          ]
          // rules: [{ required: true, message: '仪器型号必填', trigger: 'blur' }]
        }
      ],

      formBtns: [
        {
          content: '更新',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },
  created() {
    this.queryEquipmentFn()
  },
  methods: {
    //获取设备类型
    queryEquipmentFn() {
      let types = ['equipment_type', 'template_type']
      queryEquipment(types).then((res) => {
        console.log(res.data, '设备类型')
        this.formConfig[0].payload = res.data.equipment_type
        this.formConfig[1].payload = res.data.template_type
      })
    },
    handleClose() {
      this.$emit('close')
    },
    submitFn(formData) {
      this.$emit('confirm', formData)
      console.log('更新数据处理', formData)
    }
  }
}
</script>

<style></style>
